import { useEffect, useState } from 'react'
import CreatableSelect from 'react-select/creatable';
import Select, { MenuPlacement } from 'react-select'
import './styles/select.css'

export default function SearchSelect ({data, keyNameValue, keyNameText, placeholder, value, onChange, name, disabled, defaultValue, placement, onBlur, maxMenuHeight, enableCreate = false} : {data: Array<any>, keyNameValue: string, keyNameText: string, value: any, onChange: (value: any) => void, name: string, placeholder: string, disabled: boolean, defaultValue?: any, placement?: MenuPlacement, onBlur?: any, maxMenuHeight?:any, enableCreate?: boolean}){
    const formatData = data?.map((option) => {
        return ({
            value: option[keyNameValue],
            label: option[keyNameText].toUpperCase()
        })
    })

    const formatValue = formatData?.find((op:any) => op.value === value) || {value: '', label: ''}

    const customStyles = {
        // Estilo para el control (que incluye el input)
        control: (provided: any) => ({
            // Cambia el fondo del control (que incluye el input)
          // Agrega más estilos personalizados según tus necesidades
        }),
    };

    const handleCreate = (inputValue: string) => {
        const newOption = { label: -1, value: inputValue };
        onChange(newOption);
    };

    const formatCreateLabel = (inputValue: string) => `"${inputValue}"`;

    return (
        <>
            {
            !enableCreate ?
                <Select
                    isDisabled = {disabled}
                    placeholder = {placeholder}
                    options={formatData}
                    classNamePrefix={'search-select'}
                    openMenuOnFocus
                    styles={customStyles}
                    onChange={onChange}
                    value={formatValue}
                    menuPlacement={placement ? placement : 'auto'}
                    defaultValue={defaultValue}
                    onBlur={onBlur}
                    maxMenuHeight={maxMenuHeight}
                />
            : 
                <CreatableSelect
                    isDisabled={disabled}
                    placeholder={placeholder}
                    options={formatData}
                    classNamePrefix={'search-select'}
                    openMenuOnFocus
                    styles={customStyles}
                    onChange={onChange}
                    value={formatValue}
                    menuPlacement={placement ? placement : 'auto'}
                    defaultValue={defaultValue}
                    onBlur={onBlur}
                    maxMenuHeight={maxMenuHeight}
                    onCreateOption={handleCreate}
                    formatCreateLabel={formatCreateLabel}
                />
            }
        </>
    )
}